// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Device/lift type classification.
 */
export enum LiftType {
  ELEVATOR = 0,
  ESCALATOR = 1,
  MOVINGWALK = 2,
  BOT = 3,
  GPIO = 4,
}
